export default __webpack_public_path__ + "static/media/logo-globo.ddf4ed65.svg";